import React, {lazy, Suspense} from "react";
import {Navigate, useRoutes} from "react-router-dom";
import NotFound from "./page/NotFound";
import AppLoader from "./component/AppLoader";

const Home = lazy(() => import("./page/Home"));
const Settings = lazy(() => import("./page/Settings"));
const CardboardPage = lazy(() => import("./tickets/ui/pages/CardboardPage"));
const ManagementLoto = lazy(() => import("./page/ManagementLoto"));
const NumbersViewer = lazy(() => import("./page/NumbersViewer"));

const Loader = () => <AppLoader/>;

const Router = () => useRoutes([
    {
        path: "/",
        element: (
            <Suspense fallback={<Loader/>}>
                <Home/>
            </Suspense>
        ),
    },
    {
        path: "/home",
        element: <Navigate to="/" replace/>,
    },
    {
        path: "/settings",
        element: (
            <Suspense fallback={<Loader/>}>
                <Settings/>
            </Suspense>
        ),
    },
    {
        path: "/cardboard",
        element: (
            <Suspense fallback={<Loader/>}>
                <CardboardPage/>
            </Suspense>
        ),
    },
    {
        path: "/admin",
        element: (
            <Suspense fallback={<Loader/>}>
                <ManagementLoto/>
            </Suspense>
        ),
    },
    {
        path: "/numbers",
        element: (
            <Suspense fallback={<Loader/>}>
                <NumbersViewer/>
            </Suspense>
        ),
    },
    {
        path: "*",
        element: <NotFound/>,
    },
]);

export default Router
